module.exports = __webpack_public_path__ + "static/media/Apple LiGothic Medium.305e7ff8.svg";